let mainSlider;

export default () => ({
	handle: '',
	location: '',
	product: null,
	current_variant: null,
	activeSlide: 1,
	activeThumb: 1,
	quantity: 1,
	sticky_visible: false,
	url: window.location.href,
	showTax: false,

	get discount() {
		const price = this.current_variant?.price;
		const compare_price = this.current_variant?.compare_at_price;
		const compare_at_price_at = this.current_variant?.compare_at_price_at;
		if (this.location === 'at' && compare_at_price_at) {
			const formated_compare_at_price_at = Number(compare_at_price_at) * 100;
			const sale = Math.round(
				((formated_compare_at_price_at - price) * 100) / formated_compare_at_price_at,
			);
			return `-${sale} %`;
		} else {
			if (compare_price && compare_price > price) {
				const sale = Math.round(((compare_price - price) * 100) / compare_price);
				return `-${sale} %`;
			} else {
				return '';
			}
		}
	},

	get price() {
		const price = (this.current_variant?.price / 100).toFixed(2).replace('.', ',');
		return price;
	},

	get comparePrice() {
		if (this.location === 'at' && this.current_variant?.compare_at_price_at) {
			const comparePrice = Number(this.current_variant?.compare_at_price_at)
				.toFixed(2)
				.replace('.', ',');
			return comparePrice;
		} else {
			if (
				this.current_variant?.compare_at_price &&
				this.current_variant?.compare_at_price > this.current_variant?.price
			) {
				const comparePrice = (this.current_variant?.compare_at_price / 100)
					.toFixed(2)
					.replace('.', ',');
				return comparePrice;
			} else {
				return '';
			}
		}
	},

	get unitPrice() {
		let unit_pice = '';
		const price = this.current_variant?.unit_price;
		const unit = this.current_variant?.unit_price_measurement.reference_unit;
		const value = this.current_variant?.unit_price_measurement.reference_value;
		if (price && unit) {
			unit_pice = `(${(price / 100).toFixed(2)} ${
				window.Shopify.currency.active
			} / ${value}${unit})`;
		}

		return unit_pice;
	},

	get bisTitle() {
		if (this.product?.variants.length > 1) {
			return this.current_variant?.title;
		} else {
			return this.product?.title;
		}
	},

	async getProduct() {
		const url = `${window.Shopify.routes.root}products/${this.handle}?view=get-product-json`;

		const response = await fetch(url);
		if (response.status !== 200) return;
		const product = await response.json();

		this.product = product;
	},

	setDefaultVariant() {
		if (this.product) {
			if (!this.url.includes('variant=')) {
				if (this.product.options[0] === 'Title') {
					this.current_variant = this.product.selected_or_first_available_variant;
				} else if (this.product.variants.length > 0) {
					if (this.product.hidden_sku) {
						this.current_variant = this.product.variants.filter(
							(variant) => !this.product.hidden_sku.includes(variant.sku),
						)[0];
					} else {
						this.current_variant = this.product.variants[0];
					}
				} else {
					this.current_variant = this.product.selected_or_first_available_variant;
				}
				this.setActiveMedia();
			}
		}
	},

	setVariantFromURL() {
		let variant_id;
		if (this.url.includes('variant=')) {
			const variant_from_url = this.url.split('variant=')[1];
			if (variant_from_url.includes('&')) {
				variant_id = Number(variant_from_url.split('&')[0]);
			} else {
				variant_id = Number(variant_from_url);
			}
			const variant = this.product.variants.find((el) => el.id === variant_id);
			this.current_variant = variant;

			this.setActiveMedia();
		}
	},

	setVariant(title) {
		if (this.product) {
			if (this.product.variants.length < 1) return;
			const variant = this.product.variants.find((el) => el.title === title);
			this.current_variant = variant;

			this.setActiveMedia();
		}
	},

	async addToCart() {
		if (this.current_variant) {
			let productData = {
				id: this.current_variant?.id,
				quantity: Number(this.quantity),
				sections: 'cart-main,cart-drawer-sections',
			};
			if (this.current_variant.composition) {
				if (this.current_variant.composition.includes('|')) {
					const composition = this.current_variant.composition.split('|').join(', ');
					productData = {
						id: this.current_variant?.id,
						quantity: Number(this.quantity),
						properties: {
							_discoverySet: true,
							Composition: composition,
						},
						sections: 'cart-main,cart-drawer-sections',
					};
				} else {
					productData = {
						id: this.current_variant?.id,
						quantity: Number(this.quantity),
						properties: {
							_discoverySet: true,
						},
						sections: 'cart-main,cart-drawer-sections',
					};
				}
			}

			const response = await fetch(window.routes.cartAdd + '.js', {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify(productData),
			});
			const data = await response.json();

			if (response.ok) {
				this.$dispatch('cart-update', { cartData: data });
			}
			this.gtmAddToCart();
		}
	},

	async addUpsellToCart(id, config) {
		if (this.current_variant) {
			const productData = {
				id: id,
				quantity: 1,
				sections: 'cart-main,cart-drawer-sections',
			};

			const response = await fetch(window.routes.cartAdd + '.js', {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify(productData),
			});

			const data = await response.json();

			if (response.ok) {
				this.$dispatch('cart-update', { cartData: data });
			}

			this.gtmUpsellAddToCart(config);
		}
	},

	openBisPopup() {
		this.$dispatch('open-bis', { id: this.current_variant?.id, title: this.bisTitle });
	},

	setActiveMedia() {
		if (this.current_variant.featured_media) {
			let market_alt_property = '';
			switch (this.location) {
				case 'de':
					{
						const active_media = this.product.media.find(
							(el) => el.alt === this.current_variant.featured_media.alt && el.alt !== null,
						);
						if (active_media) {
							if (active_media.alt.includes('[DE]')) {
								const media = document.getElementById(`${active_media.id}`);
								if (media) {
									const index = Number(media.dataset.index);
									this.activeSlide = index;
									this.activeThumb = index;
								} else {
									const index = this.product.media.indexOf(active_media);
									this.activeSlide = index + 1;
									this.activeThumb = index + 1;
								}
							}
						}
					}
					break;
				case 'at':
					market_alt_property = 'variant_image_at_alt';
					break;
				case 'eu':
					market_alt_property = 'variant_image_eu_alt';
					break;
				case 'international':
					market_alt_property = 'variant_image_int_alt';
					break;
			}

			if (this.location !== 'de') {
				let active_variant_media = this.product.media.find(
					(el) => el.alt === this.current_variant.featured_media.alt && el.alt !== null,
				);
				if (this.current_variant[market_alt_property]) {
					active_variant_media = this.product.media.find(
						(el) => el.alt === this.current_variant[market_alt_property] && el.alt !== null,
					);
				}

				if (active_variant_media) {
					const media = document.getElementById(`${active_variant_media.id}`);
					if (media) {
						const index = Number(media.dataset.index);
						this.activeSlide = index;
						this.activeThumb = index;
					}
				}
			}
		}
	},

	enableSticky() {
		const sticky_start = this.$refs.scrollStart.offsetTop;
		const footer = document.querySelector('.footer');
		const sticky_end = footer.offsetTop - footer.offsetHeight * 4;

		if (window.scrollY >= sticky_start && window.scrollY < sticky_end) {
			this.sticky_visible = true;
		} else {
			this.sticky_visible = false;
		}
	},

	createSlider() {
		mainSlider = new window.Swiper('.product-gallery__main-slider', {
			slidesPerView: 1.05,
			speed: 500,
			breakpoints: {
				1024: {
					slidesPerView: 'auto',
				},
			},
			pagination: {
				el: '.product-gallery__pagination',
				type: 'progressbar',
			},
		});

		mainSlider.on('slideChange', (e) => {
			this.activeThumb = e.activeIndex + 1;
		});
	},

	getNumberFromString(string) {
		const formated_string = string.match(/\d+/);
		if (formated_string) {
			const nums = Number(formated_string[0]);
			if (nums) {
				return nums;
			}
		} else return '';
	},

	gtmTracking() {
		window.dataLayer = window.dataLayer || [];
		let url = '';
		let collection_handle = '';

		if (this.product.main_category.includes('&')) {
			collection_handle = this.product.main_category
				.replace(' & ', '-')
				.toLowerCase()
				.replace(' ', '-');
		} else if (this.product.main_category.includes('Root')) {
			collection_handle = 'all';
		} else {
			collection_handle = this.product.main_category.toLowerCase().replace(' ', '-');
		}

		url = `${window.Shopify.routes.root}collections/${collection_handle}`;

		window.dataLayer.push({
			event: 'EEC-ProductDetailView',
			value: (this.current_variant.price / 100).toFixed(2),
			items: [{ id: this.current_variant.sku, google_business_vertical: 'retail' }],
			ecommerce: {
				detail: {
					actionField: { list: this.product.main_category },
					products: [
						{
							id: this.current_variant.sku,
							sku: this.current_variant.sku,
							name: this.product.title,
							price: (this.current_variant.price / 100).toFixed(2),
							brand: 'Brooklyn Soap Company',
							category: this.product.main_category,
							category_path: url,
						},
					],
				},
			},
		});

		setTimeout(function () {
			// Clear the ecommerce data for subsequent hits.
			window.dataLayer.push({ ecommerce: null });
		}, 3);
	},

	gtmAddToCart() {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'EEC-AddToCart',
			value: (this.current_variant.price / 100).toFixed(2),
			ecommerce: {
				currencyCode: window.Shopify.currency.active,
				add: {
					products: [
						{
							id: this.current_variant.sku,
							sku: this.current_variant.sku,
							name: this.product.title,
							price: (this.current_variant.price / 100).toFixed(2),
							brand: 'Brooklyn Soap Company',
							category: this.product.main_category,
							quantity: this.quantity,
						},
					],
				},
			},
			items: [{ id: this.current_variant.sku, google_business_vertical: 'retail' }],
		});

		setTimeout(function () {
			// Clear the ecommerce data for subsequent hits.
			window.dataLayer.push({ ecommerce: null });
		}, 3);
	},

	gtmUpsellAddToCart(config) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			event: 'EEC-AddToCart',
			value: config.price,
			ecommerce: {
				currencyCode: window.Shopify.currency.active,
				add: {
					products: [
						{
							id: config.sku,
							sku: config.sku,
							name: config.title,
							price: config.price,
							brand: 'Brooklyn Soap Company',
							category: config.category,
							quantity: 1,
						},
					],
				},
			},
			items: [{ id: config.sku, google_business_vertical: 'retail' }],
		});

		setTimeout(function () {
			// Clear the ecommerce data for subsequent hits.
			window.dataLayer.push({ ecommerce: null });
		}, 3);
	},

	klaviyoTracking() {
		const product_collections = this.product.collections.map((collection) => collection.title);
		const compare_at_price = this.current_variant.compare_at_price
			? (this.current_variant.compare_at_price / 100).toFixed(2)
			: null;
		let _learnq = window._learnq || [];
		let tracking_object = {
			Name: this.product.title,
			ProductID: this.product.id,
			Categories: product_collections,
			ImageURL: this.product.featured_image,
			URL: `${window.location.origin}${this.product.url}`,
			Brand: this.product.vendor,
			Price: (this.current_variant.price / 100).toFixed(2),
			CompareAtPrice: compare_at_price,
		};

		setTimeout(() => {
			_learnq.push(['track', 'Viewed Product', tracking_object]);
			_learnq.push([
				'trackViewedItem',
				{
					Title: tracking_object.Name,
					ItemId: tracking_object.ProductID,
					Categories: tracking_object.Categories,
					ImageUrl: tracking_object.ImageURL,
					Url: tracking_object.URL,
					Metadata: {
						Brand: tracking_object.Brand,
						Price: tracking_object.Price,
						CompareAtPrice: tracking_object.CompareAtPrice,
					},
				},
			]);
		}, 250);
	},

	showTaxPopup() {
		if (window.innerWidth < 1024) {
			this.showTax = true;
		}
	},

	hideTaxPopup() {
		if (window.innerWidth < 1024) {
			this.showTax = false;
		}
	},

	init() {
		this.$watch('handle', () => {
			this.getProduct();
		});

		this.$watch('product', () => {
			this.setDefaultVariant();
			this.setVariantFromURL();
			this.createSlider();
			this.enableSticky();
			this.gtmTracking();
			this.klaviyoTracking();
		});

		this.$watch('activeSlide', () => {
			mainSlider.slideTo(this.activeSlide - 1);
		});
	},
});
